import "./App.css";

import Container from "./components/Swiper/Container";
import Title from "./components/Title";
import OneOne from "./components/OneOne";
import OneTwo from "./components/OneTwo";
import TwoOne from "./components/TwoOne";
import TwoTwo from "./components/TwoTwo";
import ThreeOne from "./components/ThreeOne";
import ThreeTwo, {
  refreshStatus as refreshStatus32,
  refreshGuideStatus as refreshGuideStatus32,
} from "./components/ThreeTwo";
import ThreeThree from "./components/ThreeThree";
import FourOne from "./components/FourOne";
import FourTwo from "./components/FourTwo";
import FiveOne from "./components/FiveOne";
import FiveTwo, {
  refreshStatus as refreshStatus52,
  refreshGuideStatus as refreshGuideStatus52,
} from "./components/FiveTwo";
import FiveThree, {
  refreshStatus as refreshStatus53,
  refreshGuideStatus as refreshGuideStatus53,
} from "./components/FiveThree";

import React, { useRef, useState, useEffect } from "react";
import Navi from "./components/Swiper/Navi";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Pagination } from "swiper/modules";
import { audio_move_page, SoundManager } from "./lib/SoundManager";
import { atom, useSetRecoilState } from "recoil";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

const DEFAULT_WIDTH = 1200;
const DEFAULT_HEIGHT = 913;

const scaleAtom = atom({
  key: "scale",
  default: 1,
});

export { scaleAtom };

function App() {
  const [swiper, setSwiper] = useState();
  const [update, setUpdate] = useState(false);
  const [portrait, setPortrait] = useState(false);
  const setScaleState = useSetRecoilState(scaleAtom);
  const container = useRef();

  function onResize() {
    const height = window.innerHeight;
    const scale = height / DEFAULT_HEIGHT;
    const sliders = document.getElementsByClassName("edu_slide");

    if (window.matchMedia("(orientation: portrait)").matches) {
      setPortrait(true);
    } else {
      setPortrait(false);
    }
    setScaleState(scale);
    Array.from(sliders).forEach((el) => {
      el.style.transform = `scale(${scale})`;
    });
  }

  useEffect(() => {
    window.soundManager = new SoundManager();
    onResize();
    window.addEventListener("resize", () => {
      onResize();
    });
  }, []);

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%",
        }}
      >
        <div
          ref={container}
          style={{
            width: "100%",
            height: "100%",
          }}
        >
          <Swiper
            className="mySwiper"
            direction="vertical"
            mousewheel={true}
            // pagination={{
            //   clickable: true,
            // }}
            modules={[Mousewheel]}
            allowTouchMove={true}
            onSlideChange={(_swiper, evt) => {
              window.soundManager.stopAllAudio();
              audio_move_page();
              setSwiper(_swiper);
              setUpdate(!update);
            }}
            onAfterInit={(_swiper) => {
              setSwiper(_swiper);
              setUpdate(!update);
            }}
          >
            {/* Title */}
            <SwiperSlide
              style={{
                backgroundImage: `url(images/00/bg.png)`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover",
              }}
            >
              <Container>
                <Title />
              </Container>
            </SwiperSlide>

            {/* 1 */}
            <SwiperSlide>
              <Swiper
                className="mySwiper h-screen"
                direction="horizontal"
                // mousewheel={true}
                allowTouchMove={false}
                // pagination={{
                //   clickable: true,
                // }}
                modules={[Pagination]}
              >
                {/* 1-1 */}
                <SwiperSlide
                  style={{
                    backgroundImage: `url(images/01/01/bg.png)`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                  }}
                >
                  <Container>
                    <Navi color="white" rootSwiper={swiper} tag="1-1" />
                    <OneOne rootSwiper={swiper} />
                  </Container>
                </SwiperSlide>

                {/* 1-2 */}
                <SwiperSlide
                  style={{
                    backgroundImage: `url(images/01/02/bg.png)`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                  }}
                >
                  <Container>
                    <Navi color="blue" rootSwiper={swiper} tag="1-2" />
                    <OneTwo />
                  </Container>
                </SwiperSlide>
              </Swiper>
            </SwiperSlide>

            {/* 2 */}
            <SwiperSlide>
              <Swiper
                className="mySwiper h-screen"
                direction="horizontal"
                // mousewheel={true}
                allowTouchMove={false}
                // pagination={{
                //   clickable: true,
                // }}
                modules={[Pagination]}
              >
                {/* 2-1 */}
                <SwiperSlide
                  style={{
                    backgroundImage: `url(images/02/01/bg.png)`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                  }}
                >
                  <Container>
                    <Navi color="white" rootSwiper={swiper} tag="2-1" />
                    <TwoOne rootSwiper={swiper} />
                  </Container>
                </SwiperSlide>

                {/* 2-2 */}
                <SwiperSlide
                  style={{
                    backgroundImage: `url(images/02/02/bg.png)`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                  }}
                >
                  <Container>
                    <Navi color="blue" rootSwiper={swiper} tag="2-2" />
                    <TwoTwo />
                  </Container>
                </SwiperSlide>
              </Swiper>
            </SwiperSlide>

            {/* 3 */}
            <SwiperSlide>
              <Swiper
                className="mySwiper h-screen"
                direction="horizontal"
                // mousewheel={true}
                allowTouchMove={false}
                // pagination={{
                //   clickable: true,
                // }}
                modules={[Pagination]}
              >
                {/* 3-1 */}
                <SwiperSlide
                  style={{
                    backgroundImage: `url(images/03/01/bg.png)`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                  }}
                >
                  <Container>
                    <Navi color="white" rootSwiper={swiper} tag="3-1" />
                    <ThreeOne rootSwiper={swiper} />
                  </Container>
                </SwiperSlide>

                {/* 3-2 */}
                <SwiperSlide
                  style={{
                    backgroundImage: `url(images/03/02/bg.png)`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                  }}
                >
                  <Container>
                    <Navi
                      color="blue"
                      rootSwiper={swiper}
                      tag="3-2"
                      isRefresh={true}
                      refreshStatus={refreshStatus32}
                      refreshGuideStatus={refreshGuideStatus32}
                    />
                    <ThreeTwo />
                  </Container>
                </SwiperSlide>

                {/* 3-3 */}
                <SwiperSlide
                  style={{
                    backgroundImage: `url(images/03/03/bg.png)`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                  }}
                >
                  <Container>
                    <Navi color="white" rootSwiper={swiper} tag="3-3" />
                    <ThreeThree />
                  </Container>
                </SwiperSlide>
              </Swiper>
            </SwiperSlide>

            {/* 4 */}
            <SwiperSlide>
              <Swiper
                className="mySwiper h-screen"
                direction="horizontal"
                // mousewheel={true}
                allowTouchMove={false}
                // pagination={{
                //   clickable: true,
                // }}
                modules={[Pagination]}
              >
                {/* 4-1 */}
                <SwiperSlide
                  style={{
                    backgroundImage: `url(images/04/01/bg.png)`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                  }}
                >
                  <Container>
                    <Navi color="white" rootSwiper={swiper} tag="4-1" />
                    <FourOne rootSwiper={swiper} />
                  </Container>
                </SwiperSlide>

                {/* 4-2 */}
                <SwiperSlide
                  style={{
                    backgroundImage: `url(images/04/02/bg.png)`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                  }}
                >
                  <Container>
                    <Navi color="white" rootSwiper={swiper} tag="4-2" />
                    <FourTwo />
                  </Container>
                </SwiperSlide>
              </Swiper>
            </SwiperSlide>

            {/* 5 */}
            <SwiperSlide>
              <Swiper
                className="mySwiper h-screen"
                direction="horizontal"
                // mousewheel={true}
                allowTouchMove={false}
                // pagination={{
                //   clickable: true,
                // }}
                modules={[Pagination]}
              >
                {/* 5-1 */}
                <SwiperSlide
                  style={{
                    backgroundImage: `url(images/05/01/bg.png)`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                  }}
                >
                  <Container>
                    <Navi color="white" rootSwiper={swiper} tag="5-1" />
                    <FiveOne rootSwiper={swiper} />
                  </Container>
                </SwiperSlide>

                {/* 5-2 */}
                <SwiperSlide
                  style={{
                    backgroundImage: `url(images/05/02/bg.png)`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                  }}
                >
                  <Container>
                    <Navi
                      color="white"
                      rootSwiper={swiper}
                      tag="5-2"
                      isRefresh={true}
                      refreshStatus={refreshStatus52}
                      refreshGuideStatus={refreshGuideStatus52}
                    />
                    <FiveTwo />
                  </Container>
                </SwiperSlide>

                {/* 5-3 */}
                <SwiperSlide
                  style={{
                    backgroundImage: `url(images/05/03/bg.png)`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                  }}
                >
                  <Container>
                    <Navi
                      color="white"
                      rootSwiper={swiper}
                      tag="5-3"
                      isRefresh={true}
                      refreshStatus={refreshStatus53}
                      refreshGuideStatus={refreshGuideStatus53}
                    />
                    <FiveThree />
                  </Container>
                </SwiperSlide>
              </Swiper>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
      {portrait ? (
        <div
          style={{
            background: "#000",
            opacity: "0.8",
            position: "absolute",
            top: "0px",
            left: "0px",
            width: "100vw",
            height: "100vh",
            zIndex: "1301",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              color: "#fff",
              fontSize: "2rem",
              fontFamily: "EliceDigitalBaeum_Bold",
              textAlign: "center",
              wordBreak: "keep-all",
            }}
          >
            모바일 버전은 가로형 화면에 최적화되어 있습니다.<br></br>
            가로형 화면으로 설정을 변경하고 학습을 진행해 주세요.
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default App;
